import { Input } from "antd";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

import {
  updatePlanCategory,
  createPlanCategory,
  // @ts-ignore
} from "modules/actions/PlanActions";
import { useDispatch, useSelector } from "react-redux";
import { undoToast } from "../../../utils/toast";

const WeightTitle = ({
  data,
  isNewCategory,
  sortedCategories,
  setSortedCategories,
  setEdit,
  isUnActive,
}: {
  data: any;
  isNewCategory: any;
  sortedCategories: any;
  setSortedCategories: any;
  setEdit: any;
  isUnActive: boolean;
}) => {
  const dispatch = useDispatch();
  const containerRef = useRef<any>(null);
  const [inputValue, setInputValue] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [oldData, setOldData] = useState(data);

  const { planDetails } = useSelector(
    // @ts-ignore
    (state) => state.plan.plan
  );

  const filteredCategories = planDetails?.categories?.find(
    (category: any) => category.id === data.id
  );

  const handleNewCategoryError = (error: any) => {
    // toast(error?.response?.data?.message, { type: "error" });
    setSortedCategories(sortedCategories);
  };

  const handleUndo = () => {
    const updateData = {
      name: oldData?.name,
    };

    dispatch(updatePlanCategory(data?.id, updateData, null));
  };

  const handleUpdateSuccess = () => {
    undoToast("Category name updated successfully.", "Success!", handleUndo);
  };

  const changeName = () => {
    if (inputValue.trim() === "") {
      if (data?.isNew) {
        const updatedCategories = sortedCategories.filter(
          (category: any) => category.id !== data.id
        );
        setSortedCategories(updatedCategories);
      } else {
        toast("Category name is required", { type: "error" });
        setInputValue(data?.name || "");
      }
      return;
    } else if (inputValue !== data?.name) {
      setIsEdit(false);
      setEdit(false);

      const updatedCategories = sortedCategories.map((category: any) => {
        if (category.id === data.id) {
          return {
            ...category,
            name: inputValue,
          };
        }
        return category;
      });

      setSortedCategories(updatedCategories);

      if (data?.isNew) {
        const payload = {
          name: inputValue,
          start_line: data?.start_line,
          dead_line: data?.dead_line,
          project_plan: data?.project_plan,
        };

        dispatch(createPlanCategory(payload, null, handleNewCategoryError));
      } else {
        setOldData(data);
        const updateData = {
          name: inputValue,
        };

        dispatch(
          updatePlanCategory(
            data?.id,
            updateData,
            null,
            handleUpdateSuccess,
            handleNewCategoryError
          )
        );
      }
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      setIsEdit(false);
      setEdit(false);

      changeName();
    } else if (e.key === "Escape") {
      setIsEdit(false);
      setEdit(false);
    }
  };

  const handleBlur = () => {
    changeName();
    setTimeout(() => {
      setIsEdit(false);
      setEdit(false);
    }, 100);
  };

  useEffect(() => {
    setInputValue(data?.name || "");
  }, [data]);

  useEffect(() => {
    if (isNewCategory && !data?.name && data?.isNew) {
      setIsEdit(true);
      setEdit(true);
    }
  }, [isNewCategory]);

  useEffect(() => {
    if (isEdit) {
      if (isUnActive) return;
      containerRef.current?.querySelector("input")?.focus();
    }
  }, [isEdit]);

  return (
    <WeightContainer
      onClick={() => {
        if (isUnActive) return;
        setIsEdit(true);
      }}
      ref={containerRef}
      style={{
        cursor: isUnActive ? "default" : "pointer",
      }}
    >
      {isEdit ? (
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          disabled={isUnActive}
        />
      ) : (
        <span
          style={{
            cursor: isUnActive ? "default" : "pointer",
          }}
          onClick={(e) => {
            if (isUnActive) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            setIsEdit(true);
            setEdit(true);
          }}
        >
          {inputValue}
        </span>
      )}
    </WeightContainer>
  );
};

export default WeightTitle;

const WeightContainer = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #171717;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;
